// MiniLineChart.tsx

import React from "react";
import { Line } from "react-chartjs-2";
import "./chartConfig";

import type { ChartOptions } from "chart.js";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    graphContainer: {
      height: "60px",
      width: "150px",
      position: "relative",
      [theme.breakpoints.down("md")]: {
        width: "110px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "150px",
      },
    },
  }),
);

type MiniLineChartProps = {
  dataPoints: number[];
  loading?: boolean;
};

const MiniLineChart = ({ dataPoints, loading = false }: MiniLineChartProps) => {
  const classes = useStyles();

  if (loading || !dataPoints.length) {
    return (
      <div
        className={classes.graphContainer}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span style={{ color: "#aaa", fontSize: 12 }}>Loading...</span>
      </div>
    );
  }

  // chartOptions та chartData залишаються без змін

  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { display: false },
      y: { display: false },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    elements: {
      line: {
        tension: 0.8,
        cubicInterpolationMode: "monotone",
      },
      point: { radius: 0 },
    },
  };

  const chartData = {
    labels: dataPoints.map((_, i) => `Point ${i + 1}`),
    datasets: [
      {
        label: "Mini Chart",
        data: dataPoints,
        borderColor: "#FE5A97",
        borderWidth: 2,
        fill: true,
        tension: 0.8,
        backgroundColor: (ctx: any) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;
          if (!chartArea) return "rgba(254, 90, 151, 0.2)";
          const gradient = canvasCtx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom,
          );
          gradient.addColorStop(0, "rgba(254, 90, 151, 0.25)");
          gradient.addColorStop(1, "rgba(254, 90, 151, 0)");
          return gradient;
        },
      },
    ],
  };

  return (
    <div className={classes.graphContainer}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

export default MiniLineChart;
